import { useCSATWidget } from 'hooks/useCSATWidget';

export const FirstDataQualtircs: React.FC = ({ children }) => {
  useCSATWidget();

 return <>{children}</>;
};
